(function () {
  const sectionCleanupMap = new WeakMap();

  const runSectionCleanup = (section) => {
    const cleanup = sectionCleanupMap.get(section);
    if (typeof cleanup !== "function") return;

    cleanup();
    sectionCleanupMap.delete(section);
  };

  const initProductMarkers = (section) => {
    if (!section || !section?.classList.contains("product-markers-section")) {
      return;
    }

    runSectionCleanup(section);

    const allMarkers = section.querySelectorAll(".js-product-markers__item");
    const sliderElement = section.querySelector(".product-markers__slider");
    const sectionBox = section.querySelector(".product-markers");
    const mobileContainer = section.querySelector(
      ".product-markers-for-mobile"
    );
    const allMobileCards = mobileContainer
      ? mobileContainer.querySelectorAll(".product-markers__item-inner")
      : [];
    const sliderSpeed = 700;
    const isLoop = sectionBox?.dataset.loop === "true";
    const isAutoplayEnabled = sectionBox?.dataset.autoplay === "true";
    const slideDuration = Number.parseInt(sectionBox?.dataset.slideDuration, 10);
    const autoplayDelay = Number.isFinite(slideDuration) ? slideDuration : 5000;
    let productsSlider = null;
    const markerListenersCleanup = [];

    const setActiveMarker = (activeBlockId) => {
      allMarkers.forEach((marker) => {
        marker.classList.toggle(
          "active",
          marker.dataset.blockId === activeBlockId
        );
      });
    };

    const setActiveMobileCard = (activeBlockId) => {
      allMobileCards.forEach((card) => {
        card.classList.toggle("active", card.dataset.blockId === activeBlockId);
      });
    };

    const syncMarkerToSlider = (blockId) => {
      if (!productsSlider || !blockId) return;

      const targetSlideIndex = Array.from(productsSlider.slides).findIndex(
        (slide) =>
          slide.dataset.blockId === blockId &&
          !slide.classList.contains("swiper-slide-duplicate")
      );

      if (targetSlideIndex === -1) return;

      if (isLoop) {
        productsSlider.slideToLoop(targetSlideIndex, sliderSpeed);
        return;
      }

      productsSlider.slideTo(targetSlideIndex, sliderSpeed);
    };

    const syncFromActiveSlide = () => {
      if (!productsSlider) return;

      const activeSlide = productsSlider.slides[productsSlider.activeIndex];
      const activeBlockId = activeSlide?.dataset.blockId;

      if (!activeBlockId) return;

      setActiveMarker(activeBlockId);
      setActiveMobileCard(activeBlockId);
    };

    if (sliderElement && typeof Swiper !== "undefined") {
      if (sliderElement.swiper) {
        sliderElement.swiper.destroy(true, true);
      }

      const sliderParams = {
        speed: sliderSpeed,
        loop: isLoop,
        mousewheel: {
          forceToAxis: true,
        },
        pagination: {
          el: section.querySelector(".product-markers__pagination"),
          clickable: true,
        },
        on: {
          init() {
            syncFromActiveSlide();
          },
          slideChange() {
            syncFromActiveSlide();
          },
        },
      };

      if (isAutoplayEnabled) {
        sliderParams.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          stopOnLastSlide: !isLoop,
        };
      }

      productsSlider = new Swiper(sliderElement, sliderParams);
    }

    const allMarkerCards = section.querySelectorAll(
      ".product-markers__item-inner"
    );

    const renameColorSwatchInputIds = () => {
      allMarkerCards.forEach((el, index) => {
        const allSwatchInputs = el.querySelectorAll("input[type='radio']");
        const allSwatchLabels = el.querySelectorAll("label.color-swatch");

        allSwatchInputs.forEach((input) => {
          const baseId = input.dataset.originalId || input.id;
          const baseName = input.dataset.originalName || input.name;

          input.dataset.originalId = baseId;
          input.dataset.originalName = baseName;
          input.id = `${baseId}-card${index}`;
          input.name = `${baseName}-card${index}`;
        });

        allSwatchLabels.forEach((label) => {
          const baseFor = label.dataset.originalFor || label.htmlFor;
          label.dataset.originalFor = baseFor;
          label.htmlFor = `${baseFor}-card${index}`;
        });
      });
    };
    renameColorSwatchInputIds();

    const onSelectMarker = (marker) => {
      const index = marker.dataset.index;
      const blockId = marker.dataset.blockId;

      const screenWidth =
        document.documentElement.clientWidth || window.innerWidth;

      allMarkers.forEach((marker) => {
        marker.classList.remove("mobile-initial-active");
      });

      if (productsSlider) {
        setActiveMarker(blockId);
        syncMarkerToSlider(blockId);
        return;
      }

      if (marker.classList.contains("active")) {
        if (screenWidth < 990) return;
        marker.classList.remove("active");

        return;
      }

      allMarkers.forEach((marker) => {
        marker.classList.remove("active");
      });
      marker.classList.add("active");

      allMobileCards.forEach((card) => {
        card.classList.remove("active");

        if (card.dataset.index == index) {
          card.classList.add("active");
        }
      });
    };

    allMarkers.forEach((marker) => {
      const onMarkerClick = (event) => {
        if (event.target.closest(".js-color-swatches")) return;
        onSelectMarker(marker);
      };

      const onMarkerKeyDown = (event) => {
        if (event.key === "Enter") {
          onSelectMarker(marker);
        }
      };

      marker.addEventListener("click", onMarkerClick);
      marker.addEventListener("keydown", onMarkerKeyDown);

      markerListenersCleanup.push(() => {
        marker.removeEventListener("click", onMarkerClick);
        marker.removeEventListener("keydown", onMarkerKeyDown);
      });
    });

    const onDocumentClick = (event) => {
      const screenWidth =
        document.documentElement.clientWidth || window.innerWidth;
      if (screenWidth < 990) return;

      const parentClicked = event.target.closest(".product-markers__item");
      allMarkers.forEach((marker) => {
        if (
          parentClicked != marker &&
          !event.target.closest(".js-color-swatches")
        ) {
          if (!productsSlider) {
            marker.classList.remove("active");
          }
        }
      });
    };

    document.addEventListener("click", onDocumentClick);

    sectionCleanupMap.set(section, () => {
      markerListenersCleanup.forEach((cleanup) => cleanup());
      document.removeEventListener("click", onDocumentClick);

      if (sliderElement?.swiper) {
        sliderElement.swiper.destroy(true, true);
      }
    });
  };

  const initAnimations = (section) => {
    if (
      !section ||
      !section?.classList.contains("product-markers-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const sectionContainer = section.querySelector(".product-markers");
    const imageContainer = section.querySelector(
      ".product-markers__image-container"
    );

    if (!sectionContainer || !imageContainer) return;

    ScrollTrigger.create({
      trigger: imageContainer,
      start: "50% bottom",
      end: "bottom top",
      onEnter: () => sectionContainer.classList.add("animated"),
    });
  };

  initProductMarkers(document.currentScript.parentElement);
  initAnimations(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initProductMarkers(event.target);
    initAnimations(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    runSectionCleanup(event.target);
  });
})();
